import React from "react"
import { Card, CardBody } from "reactstrap"
import ThumbnailImage from "components/Common/ThumbnailImage"
import ThemePlaceholder from "components/Common/ThemePlaceholder"

const ImporterLogoSection = ({ logo, name, loading }) => {
  return (
    <Card className="border-0 shadow-sm mb-4">
      <CardBody className="text-center">
        {loading ? (
          <ThemePlaceholder style={{ width: 150, height: 150, borderRadius: 8 }} />
        ) : (
          <ThumbnailImage
            className="border shadow-sm"
            size="xl"
            primaryImage={logo || ""}
            alt="Importer Logo"
            placeholder={name?.charAt(0) || "I"}
            placeholderClass="bg-primary text-white display-4"
          />
        )}
        {!loading && (
          <div className="mt-3">
            <h5 className="mb-0">{name || "Unnamed Importer"}</h5>
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default ImporterLogoSection